import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Container, Box, CardContent, Typography, Card, CircularProgress, CssBaseline } from '@mui/material';
import { ContentModal } from '../../../components/modal/content';
import Promotion from './modal/promocao/promotion';
import { useEffect, useState } from 'react';
import { WarningAmber } from '@mui/icons-material';
import DownloadAppCard from '../../../components/cards/downloadAppCard';
import getPromotion from '../controllers/getPromotion';
import { Root } from '../model/banners.model';
import { Root as EmpresaModel } from '../model/empresas.model';
import getBusiness from '../controllers/getBusiness';
import { ModalCustom } from '../../../components/modal';
import ModalInfoApp from './modal/infoOpenInApp/info';

export default function PromotionPage() {
    const location = useLocation();
    const { idPromotion } = useParams();
    const [promotion, setPromotion] = useState<Root | null>(null);
    const [business, setBusiness] = useState<EmpresaModel[] | null>(null);
    const [openModalInfoApp, setOpenModalInfoApp] = useState(false);
    const handleCloseModalInfoApp = () => setOpenModalInfoApp(false);

    function convertIDempresaToSlug(idEmpresa: number): string {
        const empresa = business!.find((empresa) => empresa.id === idEmpresa);
        if (empresa) {
            return empresa.slug;
        }
        return "";
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!idPromotion) return;

            try {
                const promotionResult = await getPromotion(idPromotion);
                if (!promotionResult) return;

                setPromotion(promotionResult as Root);

                const cidadeId = promotionResult?.city_id;
                if (!cidadeId) return;

                const businessResult = await getBusiness(cidadeId);
                if (businessResult) {
                    const [empresas, ids] = businessResult;
                    setBusiness(empresas);
                }
            } catch (error) {
                console.error("Erro nas requisições:", error);
            }
        };

        fetchData();
    }, [idPromotion]);

     useEffect(() => {
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/.test(userAgent);
    
            if (isMobile) {
                setOpenModalInfoApp(true);
            }
        }, []);

    if (!promotion || !business) return (
        <div
            style={{
                textAlign: "center",
            }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                }}>
                <Typography
                    gutterBottom
                    component="h2"
                    style={{
                        textAlign: "center",
                        marginTop: "60px",
                        marginBottom: "20px",
                        fontSize: "1.3rem",
                    }}>
                    Carregando promoção...
                </Typography>
                <CircularProgress
                    sx={{
                        color: "#F9146B",
                    }}
                />
            </Box>
        </div>
    );

    return (
        <>
            <CssBaseline />
            <br></br>
            <br></br>
            <br></br>
            <ModalCustom
                open={openModalInfoApp}
                title='Atenção'
                onClose={handleCloseModalInfoApp}
                actions={null}
                isMobile={true}
                slug={''}
            >
                <ModalInfoApp onClose={handleCloseModalInfoApp} />
            </ModalCustom>
            <Container maxWidth="xl" sx={{ mt: 4 }}>
            <Card
                sx={{
                    mt: 4,
                    backgroundColor: '#fdecea',
                    border: '1px solid #f5c6cb',
                    color: '#721c24',
                    borderRadius: 2,
                    boxShadow: 3,
                    mx: 'auto',
                }}
            >
                <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                    <WarningAmber sx={{ fontSize: 40, mr: 2 }} />
                    <div>
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                            Atenção!
                        </Typography>
                        <Typography variant="body1">
                            No momento não é possível realizar pedidos com promoções pelo site, baixe o APP para utilizar todos os recursos.
                        </Typography>
                    </div>
                </CardContent>
            </Card>
            <ContentModal isMobile={window.innerWidth < 700}>
                <Promotion
                    onClose={() => { }}
                    banner={promotion!}
                    empresaHasRetirada={promotion!.product_promotions[0].retirar_local == 1 ? true : false}
                    cidade_nome={promotion?.product_promotions[0].endereco.cidade!}
                    convertIDempresaToSlug={convertIDempresaToSlug}
                />
            </ContentModal>

            <div className="pt-8">
                <DownloadAppCard />
            </div>

        </Container>
        </>
        
    );
}
